
















import { createComponent, ref, computed } from "@vue/composition-api";
import { Resource } from "@megarax/client/src";
import { CsvActions } from "@megarax/client/src/csvList";
import fileDownload from "js-file-download";

interface Props {
  actions: CsvActions;
  fileName: string;
}

export default createComponent<Props>({
  components: {},
  props: {
    actions: { required: true },
    fileName: { required: true },
  },
  setup(props, ctx) {
    const fetching = ref(false);

    async function startDownload(delimiter: string) {
      fetching.value = true;
      const file = await props.actions.fetchCsvList({
        delimiter,
      });
      const fileName =
        props.fileName + "." + (delimiter == "tab" ? "tsv" : "csv");

      fileDownload(file, fileName);
      fetching.value = false;
    }

    return { startDownload, fetching };
  },
});
